module.exports = __webpack_public_path__ + "static/media/Maf_CNDH.64521a40.jpg";